import { render, staticRenderFns } from "./DRHRIB.vue?vue&type=template&id=d88c4b4c&"
import script from "./DRHRIB.vue?vue&type=script&lang=js&"
export * from "./DRHRIB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports